export const DASHBOARD_POLLING_INTERVAL_MIN_SECONDS = 10;
export const DASHBOARD_POLLING_INTERVAL_MAX_SECONDS = 10 * 60;
export const DASHBOARD_POLLING_INTERVAL_DEFAULT_SECONDS = DASHBOARD_POLLING_INTERVAL_MIN_SECONDS;
